export default "__VITE_ASSET__BO1V7UZC__"